import React, { useEffect, useState } from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import Dashboard from './pages/Dashboard';
import LinkedInAdsPage from './pages/LinkedInAdsPage';
import TestConnection from './components/TestConnection';
import { checkConnection } from './lib/supabase';
import './index.css';

function App() {
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);
  const defaultCompanyId = '431';

  useEffect(() => {
    const initializeApp = async () => {
      try {
        const status = await checkConnection();
        
        if (!status.connected) {
          console.warn('Database connection warning:', status.error);
          // Don't throw error, just log warning
        }
      } catch (err) {
        console.error('Initialization error:', err);
        // Don't set error state, just log it
      } finally {
        // Always set loading to false to prevent blank screen
        setIsLoading(false);
      }
    };

    initializeApp();
  }, []);

  // Show loading spinner for maximum 2 seconds
  useEffect(() => {
    const timeout = setTimeout(() => {
      setIsLoading(false);
    }, 2000);

    return () => clearTimeout(timeout);
  }, []);

  if (isLoading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-gray-50 dark:bg-gray-900">
        <div className="text-center">
          <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-blue-500 mx-auto"></div>
          <p className="mt-4 text-gray-600 dark:text-gray-300">Loading application...</p>
        </div>
      </div>
    );
  }

  return (
    <Router>
      <div className="min-h-screen bg-gray-50 dark:bg-gray-900">
        <div className="p-4">
          <TestConnection />
        </div>
        <Routes>
          <Route path="/" element={<Navigate to={`/company/${defaultCompanyId}`} replace />} />
          <Route path="/company/:companyId" element={<Dashboard />} />
          <Route path="/linkedin-ads/:companyId" element={<LinkedInAdsPage />} />
          <Route path="*" element={<Navigate to={`/company/${defaultCompanyId}`} replace />} />
        </Routes>
      </div>
    </Router>
  );
}

export default App;